import { Box, Button, DialogActions, Typography } from '@mui/material';
import React from 'react';
import DefaultModal from '../../components/Modals/DefaultModal';

interface ModalProps {
  open: boolean;
  setOpen: (e: boolean) => void;
  payments: number;
}

export default function SuccessPaymentModal(props: ModalProps): JSX.Element {
  return (
    <DefaultModal open={props.open} handleClose={() => props.setOpen(false)}>
      <Box sx={{ px: 6 }}>
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          You have submitted {props.payments} payments!
        </Typography>
        <Box sx={{ textAlign: 'center' }}>
          {'These payments are being processed by AllWork.'}
        </Box>
      </Box>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, pt: 3 }}>
        <Button onClick={() => props.setOpen(false)}>Close</Button>
      </DialogActions>
    </DefaultModal>
  );
}
